import { useUpdatedDate } from '~/components/Filters/@hooks';
import { UpdatedDateRangePicker } from '~/components/Filters/@component/UpdatedDateRangePicker';
import { ResponsiveProps } from '~/components/Responsive/@types';
export const DateFilter = (props: ResponsiveProps) => {
  return <Filter {...props} />;
};

const Filter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const updatedDate = useUpdatedDate();

  return (
    <UpdatedDateRangePicker
      size={size}
      disabled={updatedDate.disabled}
      dateRange={updatedDate.dateRange}
      onChange={updatedDate.setDateRange}
    />
  );
};
